__webpack_require__.p = "/interactive/basf/new-array/";